// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"85fa6dbb","239":"9429c5c3","455":"45bafb3e","977":"b66118bd"}[chunkId] + ".chunk.js";
};